import moment from 'moment';

export const blobToUint8Array = blob => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const uint8Array = new Uint8Array(reader.result);
      resolve(uint8Array);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
};

export const getBlob = async uri => {
  const response = await fetch(uri);
  const blob = await response.blob();
  return blob;
};

export function timeDifferentFun(sTime, eTime) {
  // console.log(sTime, eTime);
  const startTime = moment(moment(new Date(sTime)).format('hh:mma'), 'hh:mm A');

  const start = moment(new Date(sTime));
  const end = moment(new Date(eTime));

  const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
  const endTimeEnd = moment(
    moment(new Date(eTime)).format('hh:mma'),
    'hh:mm A'
  ).add(1, 'day');

  const duration = moment.duration(endTime.diff(startTime));
  const durationEnd = moment.duration(endTimeEnd.diff(startTime));

  const hours = Math.floor(duration.asHours());
  const hoursEnd = Math.floor(durationEnd.asHours());

  const onlyHours = `${
    end.hour() <= 12 && start.hour() <= 12
      ? hours
      : end.hour() <= 12
      ? hoursEnd
      : hours
  }`;

  return parseInt(onlyHours);
}

// Function to get the Uint8Array from the file
export const getFileAsUint8Array = async file => {
  const uri = file.preview; // Get the URI from the file's preview property
  const blob = await getBlob(uri); // Convert URI to Blob
  const uint8Array = await blobToUint8Array(blob); // Convert Blob to Uint8Array
  return uint8Array;
};

export function jobUniqueIdDoc(date, type) {
  const momentDate = moment(new Date(date));
  const hour = momentDate.hours();
  const minute = momentDate.minutes();
  const second = momentDate.seconds();
  const millisecond = momentDate.milliseconds();

  let jobUniqueId = `${type === 'Shift' ? 'SFT' : 'VST'}-${moment(date).format(
    'YYYYMMDD'
  )}-${hour < 10 ? '0' + hour : hour}${minute < 10 ? '0' + minute : minute}${
    second < 10 ? '0' + second : second
  }${millisecond}`;

  return jobUniqueId;
}

export function timeDifferent(sTime, eTime) {
  const startTime = moment(moment(new Date(sTime)).format('hh:mma'), 'hh:mm A');

  const start = moment(new Date(sTime));
  const end = moment(new Date(eTime));

  const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
  const endTimeEnd = moment(
    moment(new Date(eTime)).format('hh:mma'),
    'hh:mm A'
  ).add(1, 'day');

  const duration = moment.duration(endTime.diff(startTime));
  const durationEnd = moment.duration(endTimeEnd.diff(startTime));

  const hours = Math.floor(duration.asHours());
  const hoursEnd = Math.floor(durationEnd.asHours());
  const minutes = Math.floor(duration.asMinutes()) - hours * 60;

  // const onlyHours = `${
  //   end.hour() <= 12 && start.hour() <= 12
  //     ? hours
  //     : end.hour() <= 12
  //     ? hoursEnd
  //     : hours
  // } ${
  //   end.hour() <= 12 && start.hour() <= 12
  //     ? hours <= 1
  //       ? "hour"
  //       : "hours"
  //     : end.hour() <= 12
  //     ? hoursEnd <= 1
  //       ? "hour"
  //       : "hours"
  //     : hours <= 1
  //     ? "hour"
  //     : "hours"
  // }`;

  const onlyHours = `${
    end.hour() <= 12 && start.hour() <= 12
      ? hours
      : end.hour() <= 12
      ? hoursEnd
      : hours
  }${hours <= 1 ? 'hour' : 'hours'} ${minutes <= 0 ? '' : `${minutes}minutes`}`;

  return onlyHours;
}

export function totalAmount(sTime, eTime, baseRate) {
  const startTime = moment(moment(new Date(sTime)).format('hh:mma'), 'hh:mm A');

  const start = moment(new Date(sTime));
  const end = moment(new Date(eTime));

  const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
  const endTimeEnd = moment(
    moment(new Date(eTime)).format('hh:mma'),
    'hh:mm A'
  ).add(1, 'day');

  const duration = moment.duration(endTime.diff(startTime));
  const durationEnd = moment.duration(endTimeEnd.diff(startTime));

  const hours = Math.floor(duration.asHours());
  const hoursEnd = Math.floor(durationEnd.asHours());
  // const minutes = Math.floor(duration.asMinutes()) - hours * 60;

  let durationInDecimal =
    end.hour() <= 12 && start.hour() <= 12
      ? hours
      : end.hour() <= 12
      ? hoursEnd
      : hours;
  let payment = durationInDecimal * baseRate;
  let paymentFormatted = payment.toFixed(2);
  let paymentInDollars = '$' + paymentFormatted.toString();

  return paymentInDollars;
}

export function jobUniqueId(id, type) {
  // const momentDate = moment(date);
  // const hour = momentDate.hours();
  // const minute = momentDate.minutes();
  // const second = momentDate.seconds();
  // const millisecond = momentDate.milliseconds();

  // let jobUniqueId = `${type === "Shift" ? "SFT" : "VST"} - ${moment(
  //   date
  // ).format("YYYYMMDD")}-${hour < 10 ? "0" + hour : hour}${
  //   minute < 10 ? "0" + minute : minute
  // }${second < 10 ? "0" + second : second}${millisecond}`;

  let jobUniqueId = `${type === 'Shift' ? 'SFT' : 'VST'} - ${id}`;

  return jobUniqueId;
}

export function DateFormat(dateString) {
  const d = moment(dateString).format('MMM DD');
  return d;
}

export const Shortened = address => {
  // Convert address to string
  const addressStr = address;

  // Check if addressStr is at least 7 characters long (for example)
  // You can adjust this condition based on your specific needs
  if (addressStr.length >= 7) {
    // Extract the first three characters
    const first = addressStr.substring(0, 15);

    // Extract the last three characters
    const last = addressStr.substring(addressStr.length - 10);

    // Create the shortened format
    const shortenedFormat = `${first}....${last}`;

    // Render the shortened format
    return shortenedFormat;
  } else {
    // If addressStr is shorter than 7 characters, return the original address
    return addressStr;
  }
};

export const formatPhoneNumber = value => {
  // Remove all non-digit characters
  const cleaned = ('' + value).replace(/\D/g, '');

  // Format the phone number as 214-365-8663
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  return value;
};

export const removeFormatting = value => {
  return value.replace(/\D/g, ''); // Remove all non-digit characters
};
